import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Api } from 'src/app/core/api/Api';
import { downloadCSVFromRequest } from 'src/app/core/common/csv.download';

@Injectable({
  providedIn: 'root',
})
export class ArchivingService {
  constructor(private http: HttpClient) {}

  reportSubscription: Subscription = Subscription.EMPTY;

  fetchProtocol() {
    return this.http.get(Api.ArchivingProtocol, {
      responseType: 'text',
      observe: 'response',
    });
  }

  submitArchivingChanges(docTypes: string[]) {
    return this.http.post(Api.Archiving, {
      docTypes,
    });
  }

  downloadReport() {
    this.reportSubscription = this.fetchProtocol().subscribe(
      downloadCSVFromRequest,
    );
  }
}
